import Analytics from './components/Analytics/containers/Analytics';

export default {
  path: ':organization/analytics',
  component: Analytics,
  title: 'Analytics',
};
